import { render } from "./Expression.vue?vue&type=template&id=27622bec"
import script from "./Expression.vue?vue&type=script&setup=true&lang=js"
export * from "./Expression.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserTest/Expression.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27622bec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27622bec', __exports__)) {
    api.reload('27622bec', __exports__)
  }
  
  module.hot.accept("./Expression.vue?vue&type=template&id=27622bec", () => {
    api.rerender('27622bec', render)
  })

}


export default __exports__